import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SENTRY_INTERCEPTOR_CONFIG } from './config';
import { ErrorFilter } from './error.filter';
import { SentryInterceptor } from './interceptor';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;

import * as Sentry from '@sentry/browser';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TokenUser } from '@jms/model';

export interface SentryInterceptorConfig {
    blacklistCodes?: number[];
    whitelistCodes?: number[];
}

const environment = ConfigService.environment;

Sentry
    .init({
        dsn: environment.sentry.dsn,
        environment: environment.sentry.environment,
        release: environment.build ? environment.build : 'DEV',
        enabled: environment.sentry.environment !== 'dev'
    });

export class SentryErrorHandler implements ErrorHandler {


    constructor(
    ) { }

    handleError(err: any): void {
        console.error(err);
        Sentry.captureException(err, {
            user: {
                email: this?.user?.email
            }
        });
    }

    private get user(): TokenUser {
        const token = localStorage.getItem('auth_token');

        const jwt = new JwtHelperService({});
        const user = token
            ? jwt.decodeToken(token)
            : null;

        return user;
    }
}

@NgModule({})
export class SentryModule {

    public static forRoot(config: SentryInterceptorConfig = {}): ModuleWithProviders<SentryModule> {

        return {
            ngModule: SentryModule,
            providers: [
                {
                    provide: SENTRY_INTERCEPTOR_CONFIG,
                    useValue: config
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: SentryInterceptor,
                    multi: true
                },
                {
                    provide: ErrorHandler,
                    useClass: SentryErrorHandler
                },
                ErrorFilter,
            ]
        };
    }
}
